module.exports = __webpack_public_path__ + "img/logo-full.12a960bd.png";